import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import authCookie from './infrastructure/api/auth-cookie';

const language = authCookie.getLangFromCookie();

i18next
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    lng: language,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/accounting/frontend/locales/{{lng}}.json',
    },
  });

export default i18next;
